import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const MappingDataContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
})

export const MappingDataMenuContainer = styled.div({
  display: 'flex',
  flex: 1,
  // flexDirection: 'column',
})

export const MappingDataMenuButton = styled.div({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  padding: '1rem',
  border: `solid 1px ${v.borderGray}`,
  borderRadius: '5px',
  height: '80px',
  width: '240px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginRight: '10px',

  'div.title': {
    fontWeight: 'bold',
    marginLeft: '10px',
    fontSize: '1.2rem',
  },

  '&:hover': {
    border: `solid 1px ${v.ezMainColor}`,

    svg: {
      color: v.ezMainColor
    },

    'div.title': {
      color: v.ezMainColor
    },
  }
})